import type { ReactNode } from 'react';
import { useLayoutSlots } from '@/features/layout';
import styles from './SubSideBar.module.css';

interface SubSideBarProps {
  children?: ReactNode;
}

export function SubSideBar({ children }: SubSideBarProps) {
  const {
    subSidebarCollapsed: collapsed,
    toggleSubSidebar,
    sidebarPadded,
    sidebarTitle,
  } = useLayoutSlots();

  return (
    <aside
      data-padded={sidebarPadded}
      className={`${styles.subSideBar} ${collapsed ? styles.collapsed : ''}`}
    >
      <div className={styles.panelContent}>
        {sidebarTitle && (
          <span className={styles.sectionLabel}>{sidebarTitle}</span>
        )}
        <nav className={styles.nav}>{children}</nav>
      </div>
      <button
        className={styles.togglePill}
        type="button"
        aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        aria-expanded={!collapsed}
        onClick={toggleSubSidebar}
      >
        <span className={styles.chevron} aria-hidden="true" />
      </button>
    </aside>
  );
}
